// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoldFilledSvg from "@ant-design/icons-svg/es/asn/GoldFilled";
import AntdIcon from '../components/AntdIcon';

var GoldFilled = function GoldFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoldFilledSvg
  }));
};

GoldFilled.displayName = 'GoldFilled';
export default React.forwardRef(GoldFilled);